import { cn } from '@/utils/cn'

type Props = {
  kpiCount?: number
  showToolbar?: boolean
  showTable?: boolean
  className?: string
}

export function PageLoadingSkeleton({
  kpiCount = 4,
  showToolbar = false,
  showTable = true,
  className,
}: Props) {
  return (
    <div className={cn('dashboard-stack space-y-4', className)}>
      <div className="dashboard-shimmer h-40 rounded-2xl" />
      {showToolbar ? <div className="dashboard-shimmer h-12 max-w-xl rounded-full" /> : null}
      {kpiCount > 0 ? (
        <div className={cn('grid gap-4', kpiCount === 4 ? 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-4' : 'grid-cols-2 md:grid-cols-4')}>
          {Array.from({ length: kpiCount }, (_, i) => (
            <div key={i} className="dashboard-shimmer h-40 rounded-2xl" />
          ))}
        </div>
      ) : null}
      {showTable ? <div className="dashboard-shimmer h-72 rounded-2xl" /> : null}
    </div>
  )
}
